import { Tag } from 'antd';
import { SELLER_ORDER_STATUS_CONST } from 'constants/constants';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const StatusLabel = ({ record }) =>
  record ? <Tag color={record.color}>{record.name}</Tag> : <Tag />;
StatusLabel.propTypes = {
  record: PropTypes.object,
};

const getStatusText = ({ item }) => {
  const { t } = useTranslation();
  // if (data?.isPickup || data?.payments?.find(e => e.type === 'cod') || data?.payment?.type === 'cod') {
  //   return item.textCod || item.textPickup || item.text
  // }
  return t(item.text);
};
export const OrderStatusLabel = ({ record }) => {
  const { t } = useTranslation();

  const tempOrderStatus = SELLER_ORDER_STATUS_CONST[record?.statusOms];
  if (!tempOrderStatus) return null;

  return record ? (
    <Tag
      color={SELLER_ORDER_STATUS_CONST[record?.statusOms]?.background}
      style={{ borderRadius: 5, padding: '5px 10px', border: 'none' }}
    >
      <div
        style={{
          color: SELLER_ORDER_STATUS_CONST[record?.statusOms]?.color,
        }}
      >
        {t(
          getStatusText({
            // data: record,
            item: tempOrderStatus,
          }),
        )}
      </div>
    </Tag>
  ) : (
    <Tag />
  );
};
StatusLabel.propTypes = {
  record: PropTypes.object,
};

export default StatusLabel;
